<div (copy)="blockCopy()" (cut)="blockCut()" appBlockPrint class="no-print">
  <a routerLink="/assessment" class="button button--bare button--bare-alt back-button">
    <span class="icon icon--chevron-left"></span>
    Back to Dashboard
  </a>
  <div class="col-wrap">
    <div class="col col--secondary">
      <nav class="questions-nav nav">
        <h1 class="questions-nav__title">{{assessment.year}} {{assessment.credentialCode}} Assessment {{assessment.assessmentSequence}}</h1>
        <h2 class="questions-nav__subtitle">{{totalCorrectAnswers}} out of {{assessment.questions.length}} Correct</h2>
        <ul class="questions-nav__list nav__list">
          <ng-container *ngFor="let question of assessment.questions">
            <li class="questions-nav__item nav__item" *ngIf="question.isStarted||this.pastAssessment">
              <a routerLink="/assessment/{{assessmentResultId}}/result-review/{{question.questionId}}"
                [routerLinkActive]="['questions-nav-link--selected']" class="questions-nav-link">
                <div class="questions-nav-link__title">
                  <span *ngIf="!question.isUnanswered" [ngClass]="question.isCorrect?'icon question-nav-link__icon icon--check question-nav-link__icon--correct':'icon question-nav-link__icon icon--close question-nav-link__icon--incorrect'"></span>
                  <span *ngIf="question.isUnanswered" class="icon question-nav-link__icon icon--circle-notch question-nav-link__icon--unanswered"></span>
                  <span class="questions-nav-link__number">Question {{question.sequence}}</span>
                </div>
                <span class="questions-nav-link__text" [innerHTML]="question.stemPreview | safeHtml"></span>
              </a>
            </li>
          </ng-container>
        </ul>
      </nav>
    </div>
    <div class="col col--primary">
      <app-result-review [question]="question" [totalQuestions]="totalQuestions" [personId]="personId"></app-result-review>
    </div>
  </div>
  <small class="copyright">Copyright &copy; {{currentYear}}. The National Board for Respiratory Care, Inc. All rights
    reserved. FOR CONFIDENTIAL PERSONAL USE ONLY - DO NOT COPY, DISCLOSE, OR
    DISTRIBUTE ANY PART OR PORTION</small>  
</div>